<div class="custom-toast-content">
  <div *ngIf="message && options.enableHtml" role="alert" aria-live="polite" class="toast-message"
    [class]="options.messageClass" [innerHTML]="message">
  </div>

  <div class="custom-toast-actions" *ngIf="options?.buttons?.length">
    <button *ngFor="let btn of options.buttons" class="btn btn-link btn-sm clear" (click)="action(btn)">
      <svg *ngIf="btn.title?.toLowerCase() === 'undo'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-undo2 lucide-undo-2 w-3.5 h-3.5"><path d="M9 14 4 9l5-5"></path><path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11"></path></svg>
      {{btn.title}}
    </button>
  </div>
</div>